import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0414180"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auction" }
const _hoisted_2 = { class: "auction-content" }
const _hoisted_3 = {
  key: 0,
  class: "auction-content-left"
}
const _hoisted_4 = { class: "auction-content-left--top" }
const _hoisted_5 = { class: "price" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price-unit" }, "¥", -1))
const _hoisted_7 = { class: "price-value" }
const _hoisted_8 = {
  key: 0,
  class: "auction-content-left--bottom"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("开售详情 ")
const _hoisted_10 = {
  key: 1,
  class: "auction-content-left--bottom"
}
const _hoisted_11 = {
  key: 1,
  class: "auction-content-left"
}
const _hoisted_12 = {
  key: 2,
  class: "auction-content-left"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "auction-content-left--bottom" }, "已下架", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "auction-content-right" }
const _hoisted_16 = { key: 0 }

import { ref, computed, inject } from "vue";
import { storeToRefs } from "pinia";
import {
  Popup as VanPopup,
  showFailToast,
  showLoadingToast,
  showConfirmDialog,
  closeToast,
} from "vant";
import MainButton from "@/components/MainButton";
import Collect from "@/components/Collect";
import NftApi from "@/apis";
import { REQUEST_OK } from "@/constant/network";
import BidApi from "@/apis/bid";
import { useUsersStore } from "@/store/user";
import { openPaymentWindow } from "@/utils/payment";
import { PRE_PAY_POPUP_TYPE, SPEND_MONEY_TYPE } from "@/constant/payment";
import ConfirmTips from "./ConfirmTips.vue";
import WelfareTips from "./WelfareTips.vue";
import WelfarePopup from "./WelfarePopup.vue";
// import CopyTokenTips from "./CopyTokenTips.vue";
import { AUCTION_BTN_STAGE } from "@/constant/auction";
import { IActionConfig, IBtnInfo, useBtnAction } from "@/hooks/useBtnAction";
import RiskWarningPopup from "@/components/RiskWarningPopup/index.vue";
import SellingInfoPopup from "@/components/SellingInfoPopup/index.vue";
import ArrowRight from "@/components/ArrowRight/index.vue";
import ChooseProductCount from "@/views/ProductDetail/components/ChooseProductCount.vue";
import { formatTimestamp } from "@/utils/time";

export default /*#__PURE__*/_defineComponent({
  __name: 'ActionProduct',
  props: {
  actionConfig: {
    type: Object,
    required: true,
  },
  // contractPerformingConfig: {
  //   type: Object,
  //   required: true,
  // },
},
  emits: [
  "onRefreshTokenDetail",
  "onConfirmChooseCount",
  "onInvokeApp",
],
  setup(__props, { emit }) {

const props = __props

const userStore = useUsersStore();

const { userInfo, getIsLogin } = storeToRefs(userStore);

const {
  isShowRiskWarningPopup,
  invokeBtnAction,
  prePayAcl,
  invokePrePayConfirmed,
} = useBtnAction();




const buyoutDetailData: any = inject("buyoutDetailData");
const contractPerformingConfig: any = inject("contractPerformingConfig");
const detailData: any = inject("detailData");
const tokenId: any = inject("tokenId");

const isShowSellingInfo = ref(false);
const isChooseCount = ref(false);
const showChooseCount = ref(false);
const isShowWelfarePopup = ref(false);

const sellingInfo = computed(() => {
  return [
    formatTimestamp(+buyoutDetailData.value?.product?.startTime) + " 开售",
  ];
});

const isFutureSelling = computed(() => {
  return +buyoutDetailData.value?.product?.startTime > +new Date();
  // return true;
});

const isOnSale = computed(() => {
  return buyoutDetailData.value?.product?.status === "ON_SALE";
});

const isSoldout = computed(() => {
  return buyoutDetailData.value?.product?.status === "CLOSED";
});

const handleShowFeturePopup = () => {
  isShowSellingInfo.value = !isShowSellingInfo.value;
};

const onShowInfo = () => {
  isShowWelfarePopup.value = true;
};

const handleChooseProductCount = () => {
  showChooseCount.value = true;
};

const onClickCollect = () => {
  emit("onInvokeApp");
};

const handleClickBtn = (btnInfo?: any) => {
  if (btnInfo?.inactivated) {
    emit("onInvokeApp");
    return;
  }
  if (!isChooseCount.value) {
    handleChooseProductCount();
    return;
  }
  invokeBtnAction({
    actionConfig: props.actionConfig as any,
    handlePay: handleOffer,
  });
};

const handleOffer = async () => {
  // alert("需要创建order & 去支付页");
  const res = await BidApi.createProductOrder({
    saleOrderId: buyoutDetailData?.value?.product?.id,
  });
  if (res.code !== REQUEST_OK) {
    return showFailToast(res.message || "创建订单失败");
  }
  const { orderId } = res.data || {};

  // let tempCbUrl = "";
  // if (contractPerformingConfig.value.isProgressivePayment) {
  //   tempCbUrl = window.location.href;
  // }

  // console.log("tempCbUrl===", tempCbUrl);

  const tempCbUrl = window.location.href;

  if (orderId) {
    prePayAcl({
      type: PRE_PAY_POPUP_TYPE.RISK_WARNING,
      callback: () => {
        return openPaymentWindow({
          orderId,
          cbUrl: tempCbUrl,
          cbUrlQuery: `spendMoneyType=${SPEND_MONEY_TYPE.PURCHASING}&tokenId=${tokenId.value}&productType=${detailData?.value.type}`,
        });
      },
    });
  }
};

const onConfirmChooseCount = () => {
  showChooseCount.value = false;
  isChooseCount.value = true;
  handleClickBtn();
};

const handleConfirmRiskWarning = () => {
  invokePrePayConfirmed({ type: PRE_PAY_POPUP_TYPE.RISK_WARNING });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (__props.actionConfig.uiConfig?.isShowWelfareTips)
        ? (_openBlock(), _createBlock(WelfareTips, {
            key: 0,
            actionConfig: __props.actionConfig,
            onOnShowInfo: onShowInfo
          }, null, 8, ["actionConfig"]))
        : _createCommentVNode("", true),
      _createVNode(ConfirmTips, { actionConfig: __props.actionConfig }, null, 8, ["actionConfig"]),
      _createElementVNode("div", _hoisted_2, [
        (_unref(isOnSale))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(buyoutDetailData).product?.price), 1)
                ])
              ]),
              (_unref(buyoutDetailData).product?.stock)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createTextVNode(" 库存 " + _toDisplayString(_unref(buyoutDetailData).product?.stock) + " ", 1),
                    (_unref(isFutureSelling))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "future-txt",
                          onClick: handleShowFeturePopup
                        }, [
                          _hoisted_9,
                          _createVNode(ArrowRight, {
                            direction: isShowSellingInfo.value ? 'down' : 'up'
                          }, null, 8, ["direction"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, "暂无库存"))
            ]))
          : (_unref(isSoldout))
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, "已售出"))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14)),
        _createElementVNode("div", _hoisted_15, [
          (__props.actionConfig.uiConfig.btnInfo.text)
            ? (_openBlock(), _createBlock(_unref(MainButton), {
                key: 0,
                onOnInvokeApp: _cache[0] || (_cache[0] = () => handleClickBtn(__props.actionConfig.uiConfig.btnInfo)),
                disabled: __props.actionConfig.uiConfig.btnInfo.disabled,
                disabledType: __props.actionConfig.uiConfig.btnInfo.disabledType,
                inactivated: __props.actionConfig.uiConfig.btnInfo.inactivated,
                extClass: __props.actionConfig.uiConfig.btnInfo.extClass,
                text: __props.actionConfig.uiConfig.btnInfo.text
              }, null, 8, ["disabled", "disabledType", "inactivated", "extClass", "text"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(WelfarePopup, {
      modelValue: isShowWelfarePopup.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isShowWelfarePopup).value = $event)),
      actionConfig: __props.actionConfig,
      isSatisfyBuyQualification: 
        __props.actionConfig.uiConfig?.isSatisfyBuyQualification
      
    }, null, 8, ["modelValue", "actionConfig", "isSatisfyBuyQualification"]),
    _createVNode(_unref(VanPopup), {
      show: showChooseCount.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((showChooseCount).value = $event)),
      closeable: "",
      position: "bottom",
      "lock-scroll": "",
      "close-icon": "https://cdn.qiandaoapp.com/ued/d80d10918056cda4940aa8ccd6b01784.png",
      round: ""
    }, {
      default: _withCtx(() => [
        (showChooseCount.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(ChooseProductCount, {
                detailData: _unref(detailData),
                onOnConfirm: onConfirmChooseCount
              }, null, 8, ["detailData"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(RiskWarningPopup, {
      modelValue: _unref(isShowRiskWarningPopup),
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(isShowRiskWarningPopup) ? (isShowRiskWarningPopup).value = $event : null)),
      onOnConfirmed: handleConfirmRiskWarning
    }, null, 8, ["modelValue"]),
    _createVNode(SellingInfoPopup, {
      modelValue: isShowSellingInfo.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isShowSellingInfo).value = $event)),
      infos: _unref(sellingInfo),
      onOnConfirmed: handleConfirmRiskWarning
    }, null, 8, ["modelValue", "infos"])
  ]))
}
}

})